/* Grozs: "Mainīt izmēru" pie katras preces + atgādinājums "otrajam kreklam −10 €".
   Strādā gan izbīdāmajā grozā, gan groza lapā. Pēc izmaiņas groza saturu pārzīmē
   ar Shopify Section Rendering API (bez lapas pārlādes). */
(function () {
  var productCache = {};
  var cartPromise = null;

  function getCart(fresh) {
    if (fresh || !cartPromise) cartPromise = fetch('/cart.js').then(function (r) { return r.json(); });
    return cartPromise;
  }
  function getProduct(handle) {
    if (!productCache[handle]) productCache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.json(); });
    return productCache[handle];
  }
  function sizeIndex(p) {
    for (var i = 0; i < p.options.length; i++) {
      var n = (p.options[i].name || p.options[i]).toString().toLowerCase();
      if (n.indexOf('izm') > -1 || n.indexOf('size') > -1) return i;
    }
    return -1;
  }

  function refresh(component) {
    var id = component && component.dataset.sectionId;
    var done = getCart(true).then(function (cart) {
      var icon = document.querySelector('cart-icon');
      if (icon && icon.renderCartBubble) icon.renderCartBubble(cart.item_count, false);
      return cart;
    });
    if (!id) { location.reload(); return done; }
    return fetch(location.pathname + '?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var doc = new DOMParser().parseFromString(json[id] || '', 'text/html');
        var fresh = doc.querySelector('cart-items-component');
        if (fresh) component.innerHTML = fresh.innerHTML; else location.reload();
        return done;
      });
  }

  function openPicker(row, btn) {
    var existing = row.querySelector('.npt-cart-sizes');
    if (existing) { existing.remove(); btn.setAttribute('aria-expanded', 'false'); return; }
    var link = row.querySelector('a.cart-items__title') || row.querySelector('a[href*="/products/"]');
    if (!link) return;
    var url = new URL(link.href, location.origin);
    var handle = url.pathname.split('/products/')[1].split('/')[0];
    var current = +url.searchParams.get('variant');
    var qtyInput = row.querySelector('input[name="updates[]"]');
    var qty = qtyInput ? +qtyInput.value || 1 : 1;
    btn.setAttribute('aria-expanded', 'true');
    getProduct(handle).then(function (p) {
      var si = sizeIndex(p);
      var cur = p.variants.filter(function (v) { return v.id === current; })[0];
      if (si < 0 || !cur) return;
      var box = document.createElement('div');
      box.className = 'npt-cart-sizes';
      box.setAttribute('role', 'group');
      box.setAttribute('aria-label', 'Izvēlies citu izmēru');
      p.variants.forEach(function (v) {
        for (var i = 0; i < v.options.length; i++) if (i !== si && v.options[i] !== cur.options[i]) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'npt-size-pill' + (v.id === current ? ' is-picked' : '');
        b.textContent = v.options[si];
        if (!v.available) { b.disabled = true; }
        if (v.id === current) b.setAttribute('aria-pressed', 'true');
        b.addEventListener('click', function () {
          if (v.id === current) { box.remove(); btn.setAttribute('aria-expanded', 'false'); return; }
          box.querySelectorAll('button').forEach(function (x) { x.disabled = true; });
          b.classList.add('is-busy');
          fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: row.dataset.key, quantity: 0 }) })
            .then(function () {
              return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] }) });
            })
            .then(function () { return refresh(row.closest('cart-items-component')); })
            .catch(function () { location.reload(); });
        });
        box.appendChild(b);
      });
      var anchor = row.querySelector('.cart-items__variants-wrapper') || btn;
      anchor.parentNode.insertBefore(box, anchor.nextSibling);
    });
  }

  function enhanceRows(scope) {
    scope.querySelectorAll('tr.cart-items__table-row[data-key]').forEach(function (row) {
      if (row.dataset.nptSize || !row.querySelector('a[href*="/products/"]')) return;
      row.dataset.nptSize = '1';
      var target = row.querySelector('.cart-items__variants-wrapper') || row.querySelector('.cart-items__product-info');
      if (!target) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'npt-cart-change';
      btn.textContent = 'Mainīt izmēru';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () { openPicker(row, btn); });
      target.appendChild(btn);
    });
  }

  function updateNudge(component, cart) {
    var table = component.querySelector('table');
    if (!table) return;
    var nudge = component.querySelector('.npt-cart-nudge');
    var shirts = cart.items.reduce(function (n, i) { return n + (/krekl|džemper/i.test(i.product_type || '') || /krekls|džemperis/i.test(i.product_title) ? i.quantity : 0); }, 0);  /* krekli + džemperi (atlaide abiem) */
    var html = '';
    if (shirts === 1) html = '<strong>Pievieno vēl vienu kreklu vai džemperi – otrajam −10 €</strong> <a href="/collections/all">Skatīt dizainus →</a>';
    else if (shirts >= 2) html = '<strong>✓ Otrajam kreklam vai džemperim −10 € piemērots</strong>';
    if (!html) { if (nudge) nudge.remove(); return; }
    if (!nudge) {
      nudge = document.createElement('p');
      nudge.className = 'npt-cart-nudge';
      nudge.setAttribute('aria-live', 'polite');
      table.parentNode.insertBefore(nudge, table.nextSibling);
    }
    nudge.classList.toggle('is-done', shirts >= 2);
    if (nudge.innerHTML !== html) nudge.innerHTML = html;
  }

  window.nptRefreshCart = function () {
    var comps = document.querySelectorAll('cart-items-component');
    if (!comps.length) return getCart(true);
    return Promise.all([].map.call(comps, refresh));
  };

  var timer = null;
  function run() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var comps = document.querySelectorAll('cart-items-component');
      if (!comps.length) return;
      comps.forEach(enhanceRows);
      getCart(true).then(function (cart) { comps.forEach(function (c) { updateNudge(c, cart); }); });
    }, 120);
  }

  /* Preces lapa: galvenā cena pārrēķinās pēc daudzuma (≥ 2 krekliem jau ar "otrajam kreklam −10 €") */
  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function priceEls() {
    return [].filter.call(document.querySelectorAll('product-price .price, .sticky-add-to-cart__price .price'), function (el) { return !el.closest('.resource-card'); });
  }
  function initQtyTotal() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var qty = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    if (!qty) return;
    getProduct(m[1]).then(function (p) {
      var shirt = p.tags && p.tags.indexOf('T-krekls') > -1;
      var form = qty.closest('form');
      function update() {
        var q = parseInt(qty.value, 10) || 1;
        var idInput = form.querySelector('[name="id"]');
        var v = p.variants.filter(function (x) { return String(x.id) === String(idInput && idInput.value); })[0] || p.variants[0];
        priceEls().forEach(function (el) {
          if (q < 2) {
            if (el.dataset.nptOrig != null) { el.innerHTML = el.dataset.nptOrig; delete el.dataset.nptOrig; }
            return;
          }
          if (el.dataset.nptOrig == null) el.dataset.nptOrig = el.innerHTML;
          var full = v.price * q;
          var total = shirt ? full - 1000 : full;
          var note = shirt ? '<s>' + money(full) + '</s> par ' + q + ' gab. · otrajam −10 €' : 'par ' + q + ' gab.';
          el.innerHTML = '<bdi>' + money(total) + '</bdi> <small class="npt-qty-note" style="font-size:.5em;opacity:.75;white-space:nowrap;margin-left:6px">' + note + '</small>';
        });
      }
      ['input', 'change'].forEach(function (ev) { form.addEventListener(ev, function () { setTimeout(update, 0); }); });
      form.addEventListener('click', function () { setTimeout(update, 30); });
      document.addEventListener('variant:update', function () { setTimeout(update, 60); });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initQtyTotal); else initQtyTotal();

  /* Izbīdāmais grozs aizveras, uzklikšķinot ārpus tā (klikšķis ārpusē tikai aizver, nevis atver saiti zem tā) */
  document.addEventListener('pointerdown', function (e) {
    var d = document.getElementById('cart-drawer');
    if (!d || !d.isOpen || typeof d.close !== 'function') return;
    var dlg = d.querySelector('dialog');
    if (!dlg || dlg.contains(e.target) || e.target.closest('[aria-controls="cart-drawer"]')) return;
    var r = dlg.getBoundingClientRect();
    if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) return;
    d.close();
    var swallow = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
    document.addEventListener('click', swallow, { capture: true, once: true });
    setTimeout(function () { document.removeEventListener('click', swallow, { capture: true }); }, 600);
  }, true);

  var observer = new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var t = list[i].target;
      if (t.closest && (t.closest('cart-items-component') || t.querySelector && t.querySelector('cart-items-component'))) {
        if (!(t.closest && t.closest('.npt-cart-nudge, .npt-cart-sizes'))) { run(); return; }
      }
    }
  });
  function start() { run(); observer.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
